import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { createNullObject, PartialWithRequired } from './utils';

export const productAnalyticsBpContextName = 'product_analytics_context';
export const productAnalyticsBpContextSchemaVersion = 167;
export type ProductAnalyticsBpContext = Fields<
  typeof productAnalyticsBpContextName,
  typeof productAnalyticsBpContextSchemaVersion
>;

const defaults = createNullObject([
  'copy',
  'element',
  'flow',
  'modal_name',
  'device_type',
  'is_user_facing_data',
  'scrolling_percentage',
  'entity_type',
]);

export type ProductAnalyticsBpContextFields = PartialWithRequired<
  ProductAnalyticsBpContext,
  'feature' | 'location' | 'product'
> & {
  cta_location_id?: string | null;
};

export const buildProductAnalyticsBpContext = (fields: ProductAnalyticsBpContextFields) => {
  return {
    product_analytics_context: new EventContext(
      productAnalyticsBpContextName,
      productAnalyticsBpContextSchemaVersion,
      {
        ...defaults,
        ...fields,
        cta_location_id: fields.cta_location_id ?? null,
      },
    ),
  };
};
